import { render, staticRenderFns } from "./Roots.vue?vue&type=template&id=5b9086a4&"
import script from "./Roots.vue?vue&type=script&lang=js&"
export * from "./Roots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports